module.exports = __webpack_public_path__ + "img/1f602.af51e8d.svg";